import { LoginForm } from "@/components/auth/LoginForm";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { PublicOnlyRoute } from "@/components/layout/PublicOnlyRoute";
import { SEO } from "@/components/common/SEO";

const Login = () => {
  return (
    <PublicOnlyRoute>
      <div className="flex flex-col min-h-screen">
        <SEO 
          title="Login"
          description="Log in to your IntelliStitch account to access your knitting patterns, track progress, and join our community."
          type="website"
        />
        <Navbar />
        <main className="flex-1 container py-10">
          <div className="max-w-md mx-auto space-y-6">
            <LoginForm />
          </div>
        </main>
        <Footer />
      </div>
    </PublicOnlyRoute>
  );
};

export default Login;
